import EnlargedImageModal from "components/EnlargedImageModal";
import Image from "next/image";
import { ReactElement, useState } from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const ImageOuterView = styled.div`
  width: 94px;
  height: 94px;
  border-radius: 3px;
  overflow: hidden;
  cursor: pointer;
`;

interface Props {
  imageUrl: string | null;
  title: string;
}

export default function CredentialImageContainer({
  imageUrl,
  title,
}: Props): ReactElement {
  const [imageModalEnabled, setImageModalEnabled] = useState<boolean>(false);

  const handleEnableModal = () => {
    setImageModalEnabled(true);
  };

  const handleCloseImage = () => {
    setImageModalEnabled(false);
  };

  if (!imageUrl) {
    return <div />;
  }

  return (
    <>
      <Container>
        <ImageOuterView onClick={handleEnableModal}>
          <Image
            src={imageUrl}
            width="94px"
            height="94px"
            // layout='fill'
          />
        </ImageOuterView>
      </Container>
      <EnlargedImageModal
        modalEnabled={imageModalEnabled}
        handleClose={handleCloseImage}
        imageUrl={String(imageUrl)}
        title={title}
      />
    </>
  );
}
